export default __webpack_public_path__ + "static/media/default.e220ccacad95a583f971e64b28648ff0.png";